import ArrowDownDisabledIcon from "Assets/Icons/ArrowDownDisabledicon";
import ArrowDownIcon from "Assets/Icons/ArrowDownIcon";
import PackageSelectIcon from "Assets/Icons/PackageSelectIcon";
import { ColourOption } from "Components/CommonComponents/customselectdata";
import Typography from "Components/CommonComponents/Typography";
import { default as ReactSelect, ValueContainerProps } from "react-select";
import {
  components,
  SingleValueProps,
  IndicatorsContainerProps,
  ControlProps,
} from "react-select";
import "./customSelect.css";

interface MyValueContainerProps extends ValueContainerProps<ColourOption> {
  iconInvalueContainer?: boolean;
}
const SingleValue = ({
  children,
  ...props
}: SingleValueProps<ColourOption>) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);
const ValueContainer = ({
  children,
  iconInvalueContainer,
  ...props
}: MyValueContainerProps) => {
  console.log(
    props,
    props?.selectProps,
    iconInvalueContainer,
    "ValueContainerProps"
  );
  return (
    <components.ValueContainer {...props}>
      <div className="d-flex flex-row align-items-center">
        <PackageSelectIcon />
        &nbsp;
        {children}
      </div>
    </components.ValueContainer>
  );
};

const IndicatorsContainer = (
  props: IndicatorsContainerProps<ColourOption, true>
) => {
  return (
    <div
      style={{
        background: "transparent",
        top: props?.selectProps?.name == "customname" ? "0px" : "-1px",
        position: "relative",
      }}
    >
      <components.IndicatorsContainer {...props} />
    </div>
  );
};
const ControlComponent = (props: ControlProps<ColourOption, false>) => {
  return (
    <div className="d-flex flex-column controlSelectContainer">
      <components.Control {...props} />
    </div>
  );
};
export const MenuList = (props: any) => {
  return (
    <components.MenuList {...props}>
      <div className="menuHeaderStyleMultiSelect">
        <div className="w-100 d-flex flex-column justify-content-start align-items-center">
          <div className="d-flex w-100 flex-row justify-content-end mr-2 mb-1">
            <div
              onClick={() => props.selectProps.addDocumentTypeHandler()}
              className="cursorHoverCSS"
            >
              <Typography variant="body3" color="primary">
                Add Document Type
              </Typography>
            </div>
          </div>
        </div>
      </div>
      {props.children}
    </components.MenuList>
  );
};
const CustomSelect = (props: any) => {
  const customStyles = {
    control: (base: any) => ({
      ...base,
      height: props.height ? `${props.height} !important` : "38px !important",
      minHeight: props.height
        ? `${props.height} !important`
        : "38px !important",
      zIndex: 1,
      padding: "0px 4px 0px 4px",
      width: props.width ? props.width : "auto",
      borderColor: props.disabled
        ? "transparent"
        : props.isSelected
        ? "#00B0F5"
        : props.isFocused
        ? "#ebebeb"
        : props.isRequired
        ? "red"
        : "#CCCCCC",
      backgroundColor: props.isSelected
        ? "#E5F6FF"
        : props.disabled
        ? "rgb(242, 242, 242)"
        : "white",
    }),
    container: (base: any) => ({
      ...base,
      backgroundColor: "transparent",
      minWidth: props.width ? props.width : "auto",
      zIndex: props.isInPerformance ? 8 : 1,
    }),
    singleValue: (base: any) => ({
      ...base,
      background: "transparent",
      color: "#545454",
      display: "flex",
      fontSize: "16px",
      fontWeight: "400",
    }),
    option: (base: any, state: any) => ({
      ...base,
      height: "40px",
      display: "flex",
      alignItems: "center",
      padding: "4px 4px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      fontSize: "16px",
      fontWeight: "400",
      zIndex: 10,
      color: state.isSelected ? "#00B0F5" : "inherit",
      backgroundColor: state.isSelected ? "transparent" : "inherit",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: 8,
      marginTop: 4,
      padding: "16px 0px 16px 16px",
      background: "#FFFFFF",
      overflow: "hidden",
      zIndex: 10000,
      position: "absolute",
      minWidth: "180px", // Set your desired min width
    }),
    menuList: (base: any) => ({
      ...base,
      overflowX: "hidden",
      zIndex: 10000,
    }),
    valueContainer: (base: any) => ({
      ...base,
      width: props.width ? props.width : "auto",
      textOverflow: "ellipsis",
      whiteSpace: "normal",
      overflow: "hidden",
      top: props.top ? props.top : "0px",
      fontSize: "16px",
      fontWeight: "400",
      color: "red",
      padding: "0px 2px 0px 8px",
      justifyContent: "flex-start",
      marginTop: "4px",
    }),
  };
  const opt = {
    Control: ControlComponent,
    IndicatorsContainer,
    DropdownIndicator,
    IndicatorSeparator: null,
  };
  if (props.withSearch) {
    return (
      <div>
        <ReactSelect
          {...props}
          styles={customStyles}
          components={{
            SingleValue,
            MenuList,
            DropdownIndicator,
            IndicatorSeparator: null,
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 8,
            colors: {
              ...theme.colors,
            },
          })}
          options={
            props.options && Array.isArray(props.options)
              ? [...props.options]
              : [{ label: "Select", value: null }]
          }
          isDisabled={props.disabled ? true : false}
          onChange={(selected: any) => {
            return props.onChange(selected);
          }}
        />
      </div>
    );
  }
  return (
    <ReactSelect
      {...props}
      styles={customStyles}
      menuPlacement={props.menuPlacement ? props.menuPlacement : "bottom"}
      theme={(theme) => ({
        ...theme,
        borderRadius: 8,
        colors: {
          ...theme.colors,
          primary: "#E1E2E9",
        },
      })}
      components={
        props.iconInvalueContainer
          ? {
              ...opt,
              ValueContainer,
            }
          : {
              ...opt,
            }
      }
      options={
        props.options && Array.isArray(props.options) ? [...props.options] : []
      }
      isDisabled={props.disabled ? true : false}
      onChange={(selected: any) => {
        return props.onChange(selected);
      }}
    />
  );
};
export const DropdownIndicator = (props: any) => {
  if (props.disabled) {
    return <ArrowDownDisabledIcon className="mr-1" />;
  } else {
    return <ArrowDownIcon className="mr-1" />;
  }
};

CustomSelect.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*",
  },
};

export default CustomSelect;
